import PropTypes from 'prop-types';
import { css } from 'styled-components';
import { palette } from '../../constants/styles';

export const Default = {
  container: css`
    width: 100%;
    margin: 20px 0;
    padding: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid black;
  `,
};

export const Underline = {
  container: css`
    background-color: transparent;
    border-bottom: 1px dashed ${palette.primaryColor};
    outline: none;
  `,
  placeholder: css`
    color: #000;
    opacity: 0.3;
  `,
};

export const AsSelector = {
  container: css`
    font-size: 16px;
    background-color: transparent;
    border-bottom: 1px dashed ${palette.primaryColor};
    outline: none;
  `,
  placeholder: css`
    color: #000;
    opacity: 0.3;
  `,
};


export const ThemeShape = PropTypes.shape({
  container: PropTypes.array,
});
